import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"

import { TCustomizationContextState } from "./types"

const initState: TCustomizationContextState = {
  data: {
    list: null,
    error: null,
  },
  item: {
    data: null,
    error: null,
    isLoading: false,
  },
}

export const CustomizationContext = createContext(initState)

export const CustomizationProvider = createProvider(
  CustomizationContext,
  initState
)
